module.exports = __webpack_public_path__ + "img/webinar-2026-10-12.webp";